<!-- eslint-disable prettier/prettier -->
<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbs" />

    <!-- Múltiplas lojas -->
    <template v-if="rawStores.length > 1">
      <b-card v-for="store in storesList" :key="store.storeId" class="mb-3">
        <b-card-header class="p-1">
          <b-button v-b-toggle="`collapse-${store.storeId}`" block variant="light"
            class="position-relative text-center">
            <!-- Conteúdo centralizado -->
            <div class="d-inline-flex align-items-center justify-content-center w-100">
              {{ store.name || `Loja ${store.storeId}` }}
              <b-badge :variant="store.isOpen ? 'success' : 'danger'" class="ml-2">
                {{ store.isOpen ? 'Caixa Aberto' : 'Caixa Fechado' }}
              </b-badge>
              <b-badge v-if="store.isOpen" :variant="store.isOfDay ? 'info' : 'secondary'" class="ml-2">
                {{ store.isOfDay ? 'Do Dia' : 'Não é do Dia' }}
              </b-badge>
            </div>

            <!-- Spinner sem override de transform -->
            <b-spinner v-if="store.isSimple" small label="Carregando caixa..." class="position-absolute"
              style="right: 1rem; top: 50%; margin-top: -0.5rem;" />
          </b-button>
        </b-card-header>

        <b-collapse :id="`collapse-${store.storeId}`">
          <b-card-body>
            <!-- Simplificado: mostra spinner -->
            <div v-if="store.isSimple" class="text-center py-3">
              <b-spinner small label="Carregando caixa..." class="mr-2" />
              Carregando caixa...
            </div>

            <!-- Completo: mostra detalhes -->
            <div v-else>
              <!-- 1) Container relative -->
              <div class="checkout-container">
                <!-- 2) Blur condicional -->
                <div :class="{ blur: refreshing[store.storeId] }">
                  <CheckoutDetails :checkout="store.checkout"
                    :checkouts="{ data: store.hasValid ? [store.checkout] : [] }">
                    <template #actions="{ onOpenCheckout }">
                      <div v-if="!store.isOpen" class="d-flex justify-content-between align-items-center mb-2">
                        <b-button variant="primary" size="sm" @click="onOpenCheckout(store.storeId)">
                          <span class="fas fa-plus mr-1" /> Abrir Novo Caixa
                        </b-button>
                        <b-button variant="secondary" size="sm" :disabled="refreshing[store.storeId]"
                          @click="onRefreshClick(store.storeId)">
                          <b-spinner v-if="refreshing[store.storeId]" small label="Atualizando..." class="mr-1" />
                          <span v-else>
                            <span class="fas fa-sync-alt mr-1" /> Atualizar
                          </span>
                        </b-button>
                      </div>
                      <div v-else class="d-flex justify-content-end align-items-center mb-2">
                        <b-button variant="secondary" size="sm" :disabled="refreshing[store.storeId]"
                          @click="onRefreshClick(store.storeId)">
                          <b-spinner v-if="refreshing[store.storeId]" small label="Atualizando..." class="mr-1" />
                          <span v-else>
                            <span class="fas fa-sync-alt mr-1" /> Atualizar
                          </span>
                        </b-button>
                      </div>
                    </template>
                  </CheckoutDetails>
                </div>

                <!-- 3) Overlay com spinner -->
                <div v-if="refreshing[store.storeId]"
                  class="overlay-spinner d-flex align-items-center justify-content-center">
                  <b-spinner label="Atualizando..." />
                </div>
              </div>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>
    </template>

    <!-- Única loja -->
    <template v-else>
      <div class="mb-3">
        <!-- Simplificado: mostra spinner -->
        <div v-if="singleStore.isSimple" class="text-center py-3">
          <b-spinner small label="Carregando caixa..." class="mr-2" />
          Carregando caixa...
        </div>

        <!-- Completo: mostra detalhes com blur/overlay -->
        <div v-else>
          <div class="checkout-container">
            <!-- conteúdo borrado enquanto refreshing estiver ativo -->
            <div :class="{ blur: refreshing[singleStore.storeId] }">
              <CheckoutDetails :checkout="singleStore.checkout"
                :checkouts="{ data: singleStore.hasValid ? [singleStore.checkout] : [] }">
                <template #actions="{ onOpenCheckout }">
                  <div v-if="!singleStore.isOpen" class="d-flex justify-content-between align-items-center mb-2">
                    <b-button variant="primary" size="sm" @click="onOpenCheckout(singleStore.storeId)">
                      <span class="fas fa-plus mr-1" /> Abrir Novo Caixa
                    </b-button>
                    <b-button variant="secondary" size="sm" :disabled="refreshing[singleStore.storeId]"
                      @click="onRefreshClick(singleStore.storeId)">
                      <b-spinner v-if="refreshing[singleStore.storeId]" small label="Atualizando..." class="mr-1" />
                      <span v-else>
                        <span class="fas fa-sync-alt mr-1" /> Atualizar
                      </span>
                    </b-button>
                  </div>
                  <div v-else class="d-flex justify-content-end align-items-center mb-2">
                    <b-button variant="secondary" size="sm" :disabled="refreshing[singleStore.storeId]"
                      @click="onRefreshClick(singleStore.storeId)">
                      <b-spinner v-if="refreshing[singleStore.storeId]" small label="Atualizando..." class="mr-1" />
                      <span v-else>
                        <span class="fas fa-sync-alt mr-1" /> Atualizar
                      </span>
                    </b-button>
                  </div>
                </template>
              </CheckoutDetails>
            </div>

            <!-- overlay -->
            <div v-if="refreshing[singleStore.storeId]"
              class="overlay-spinner d-flex align-items-center justify-content-center">
              <b-spinner label="Atualizando..." />
            </div>
          </div>
        </div>
      </div>
    </template>
  </Layout>
</template>
<script>
import { mapState } from 'vuex'
import Layout from '@/views/Layout'
import CheckoutDetails from '@/components/Checkouts/CheckoutDetails'
import services from '@/services'

export default {
  name: 'StoresIndexView',
  components: { Layout, CheckoutDetails },

  data() {
    return {
      refreshTimers: {},
      refreshing: {}
    }
  },

  computed: {
    ...mapState('multiStoresSse', ['toyUpdates']),

    rawStores() {
      return Object.entries(this.toyUpdates).map(([storeId, data]) => ({
        storeId,
        data
      }))
    },
    storesList() {
      return this.rawStores.map(({ storeId, data }) => {
        const checkoutData = data.checkout
        const isComplete =
          checkoutData &&
          typeof checkoutData === 'object' &&
          'report' in checkoutData
        const isSimple = !isComplete
        const hasValid = checkoutData && checkoutData.closedAt !== undefined

        return {
          storeId,
          name: data.store?.name,
          isSimple,
          hasValid,
          checkout: hasValid ? checkoutData : null,
          isOpen: hasValid && checkoutData.closedAt === null,
          isOfDay:
            hasValid &&
            new Date(checkoutData.createdAt).toDateString() ===
              new Date().toDateString()
        }
      })
    },

    singleStore() {
      return (
        this.storesList[0] || {
          storeId: null,
          isSimple: false,
          hasValid: false,
          checkout: null,
          isOpen: false,
          isOfDay: false
        }
      )
    },

    breadcrumbs() {
      return [
        { text: 'Início', to: { name: 'HomeIndex' } },
        { text: 'Caixas', to: { name: 'CheckoutsIndex' }, active: true }
      ]
    }
  },

  watch: {
    storesList: {
      handler(newList) {
        const simples = newList.filter((s) => s.isSimple).map((s) => s.storeId)
        if (simples.length) this.scheduleRefresh(simples)
        else this.clearRefreshTimers()
      },
      deep: true
    },
    toyUpdates: {
      handler(newVal) {
        Object.keys(this.refreshing).forEach((id) => {
          if (this.refreshing[id] && newVal[id]) {
            this.$set(this.refreshing, id, false)
            console.log(`🔔 Parou animação de Atualizar para loja ${id}`)
          }
        })
      },
      deep: true
    }
  },

  mounted() {
    const allIds = this.rawStores.map((s) => s.storeId)
    if (allIds.length) {
      this.refreshAllCheckouts(allIds)
    }
  },

  methods: {
    scheduleRefresh(storeIds) {
      storeIds.forEach((id) => {
        if (!this.refreshTimers[id]) {
          this.refreshTimers[id] = setTimeout(async () => {
            await this.refreshCheckout(id)
            // libera o slot pra nova agenda futura
            this.refreshTimers[id] = null
          }, 20000)
        }
      })
    },
    clearRefreshTimers() {
      Object.values(this.refreshTimers).forEach((timerId) => {
        clearTimeout(timerId)
      })
      this.refreshTimers = {}
    },

    // novo handler para disparar animação e chamada
    async onRefreshClick(storeId) {
      this.$set(this.refreshing, storeId, true)
      try {
        await this.refreshCheckout(storeId)
      } catch {
        this.$set(this.refreshing, storeId, false)
      }
    },

    async refreshCheckout(storeId) {
      return services.reports.fetchRefreshCheckoutCache(storeId)
    },

    async refreshAllCheckouts(storeIds) {
      if (storeIds.length > 1) {
        await Promise.all(storeIds.map((id) => this.refreshCheckout(id)))
      } else if (storeIds.length === 1) {
        await this.refreshCheckout(storeIds[0])
      }
    }
  }
}
</script>

<style scoped>
.checkout-container {
  position: relative;
}

/* aplica blur no conteúdo */
.blur {
  filter: blur(4px);
}

/* overlay sobre todo o container */
.overlay-spinner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: none;
  /* opcional */
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  /* acima de outros conteúdos */
}
</style>
